
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="accueil" 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/38220e5f60ac55c50b6fb808ec68aad1.jpg')`
      }}
    >
      <div className="w-full container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-white text-center">
            {/* Logo officiel FMS Protec centré */}
            <div className="flex items-center justify-center mb-12">
              <img 
                src="https://static.readdy.ai/image/65f2e1185e53fe0634cf9c94c27d7d49/d8e3bf9253c425eafa8f952fc0b0f1da.png" 
                alt="FMS Protec - Entreprise Sécurité Belgique" 
                className="h-[168px] w-auto object-contain"
              />
            </div>

            {/* Titre SEO optimisé */}
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              <span className="text-orange-400">Entreprise Sécurité Belgique</span><br />
              <span className="text-blue-400">Charleroi</span> • Bruxelles • Namur • Liège
            </h1>

            {/* Sous-titre avec mots-clés SEO */}
            <h2 className="text-xl md:text-2xl mb-4 text-gray-200 max-w-3xl mx-auto">
              Installation <strong>alarme maison</strong>, <strong>caméra de surveillance</strong>, <strong>contrôle d'accès</strong> et <strong>détecteur incendie</strong> en Belgique
            </h2>
            
            <div className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
              <span className="text-orange-400 font-semibold">"LA SÉRÉNITÉ AU-DEHORS ET LA SÉCURITÉ AU DEDANS"</span><br />
              Solutions pour particuliers et PME • Devis gratuit
            </div>

            {/* Boutons d'action */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                variant="primary" 
                size="lg"
                onClick={scrollToContact}
                className="shadow-2xl"
              >
                <i className="ri-phone-line mr-2"></i>
                Devis gratuit Belgique
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                onClick={() => {
                  const element = document.getElementById('pourquoi-nous');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="border-white text-white hover:bg-white hover:text-gray-900"
              >
                <i className="ri-arrow-down-line mr-2"></i>
                Nos services sécurité
              </Button>
            </div>

            {/* Badges de confiance SEO */}
            <div className="mt-8 flex flex-wrap gap-4 text-sm justify-center">
              <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
                <i className="ri-map-pin-line mr-2 text-orange-400"></i>
                Service toute la Belgique
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
                <i className="ri-shield-check-line mr-2 text-blue-400"></i>
                Installation professionnelle
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
                <i className="ri-customer-service-line mr-2 text-green-400"></i>
                Support technique 24/7
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
